import LTR from "@brand-icons/ploom/device-time/device-time-ltr.svg";
import RTL from "@brand-icons/ploom/device-time/device-time-rtl.svg";

import { iconFactory } from "../iconFactory";

export const DeviceTimeIcon = iconFactory("DeviceTimeIcon", LTR, RTL);
